module.exports = __webpack_public_path__ + "img/pigai-mobile-order.168b0f32.png";